(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function focusContactConfirmation() {
    const confirmation = document.querySelector('.contact-form__success');
    if (confirmation) {
      confirmation.focus({ preventScroll: true });
      confirmation.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusContactConfirmation, { once: true });
  } else {
    focusContactConfirmation();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["copyfast-print-areas"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('.copyfast-editor-active')) return;
    const positions = ['Center', 'Upper right', 'Upper left', 'Lower left', 'Lower right'];
    const artwork = new Map();
    let replaying = false;
    let placementTimer;
    document.addEventListener('click', event => {
      const remove = event.target.closest('.cl_remove-image');
      if (!remove) return;
      const input = remove.closest('.customily-file-input')?.querySelector('input[type="file"]');
      if (input) artwork.delete(input.dataset.elementId);
    }, true);
    const isPlacement = element => element instanceof HTMLSelectElement &&
      positions.every(position => Array.from(element.options).some(option => option.textContent.trim() === position));
    document.addEventListener('change', event => {
      if (event.target instanceof HTMLInputElement && event.target.type === 'file' && !replaying) {
        if (event.target.files.length) artwork.set(event.target.dataset.elementId, event.target.files[0]);
        else artwork.delete(event.target.dataset.elementId);
      }
      if (!isPlacement(event.target) || !artwork.size) return;
      clearTimeout(placementTimer);
      placementTimer = setTimeout(() => {
        replaying = true;
        for (const input of document.querySelectorAll('input[type="file"][data-element-id]')) {
          const file = artwork.get(input.dataset.elementId);
          if (!file) continue;
          const transfer = new DataTransfer();
          transfer.items.add(file);
          input.files = transfer.files;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        replaying = false;
      }, 350);
    }, true);
  })();
  (() => {
    const marker = document.querySelector('[data-copyfast-gallery-label]');
    if (!marker) return;
    const isHoodie = marker.dataset.copyfastProduct === 'custom-logo-hoodie';
    const isClassic = marker.dataset.copyfastProduct === 'custom-company-t-shirts';
    const classicFitImages = {"black":{"front":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-black-front.jpg?v=1790989638","back":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-black-back.jpg?v=1790989668"},"charcoal":{"front":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-charcoal-front.jpg?v=1790989625","back":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-charcoal-back.jpg?v=1790989656"},"navy":{"front":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-navy-front.jpg?v=1790989642","back":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-navy-back.jpg?v=1790989673"},"red":{"front":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-red-front.jpg?v=1790989630","back":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-red-back.jpg?v=1790989660"},"royal":{"front":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-royal-front.jpg?v=1790989634","back":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-royal-back.jpg?v=1790989664"},"sport-grey":{"front":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-sport-grey-front.jpg?v=1790989647","back":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-sport-grey-back.jpg?v=1790989677"},"white":{"front":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-white-front.jpg?v=1790989651","back":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-g5000-fit-white-back.jpg?v=1790989681"}};
    const sampleFitImages = {"unisex-garment-dyed-t-shirt": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-comfort-colors-1717-white-front-fit.jpg?v=1790992081", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-comfort-colors-1717-white-fit-back.jpg?v=1790991970", "preview": "White fit sample \u2014 front", "color": "White"}, "unisex-softstyle-t-shirt": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-gildan-64000-white-front-fit.jpg?v=1790992086", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-gildan-64000-white-back-fit.jpg?v=1790992090", "preview": "White fit sample \u2014 front", "color": "White"}, "kids-heavy-cotton\u2122-tee": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-gildan-5000b-white-front-fit.jpg?v=1790992094", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-gildan-5000b-white-back-fit.jpg?v=1790992099", "preview": "White fit sample \u2014 front", "color": "White"}, "womens-boxy-tee": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-comfort-colors-3023cl-ivory-front-fit.jpg?v=1790992120", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-comfort-colors-3023cl-ivory-back-fit.jpg?v=1790992124", "preview": "Ivory fit sample \u2014 front", "color": "Ivory"}, "unisex-garment-dyed-sweatshirt": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-comfort-colors-1566-white-front-fit.jpg?v=1790992128", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-comfort-colors-1566-white-back-fit.jpg?v=1790992132", "preview": "White fit sample \u2014 front", "color": "White"}, "unisex-heavy-blend\u2122-full-zip-hooded-sweatshirt": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-gildan-18600-sport-grey-front-fit.jpg?v=1790992136", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-gildan-18600-sport-grey-back-fit.jpg?v=1790992168", "preview": "Sport Grey fit sample \u2014 front", "color": "Sport Grey"}, "unisex-sweatshirt": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-awdis-jh030-white-fit-front.png?v=1790992297", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-awdis-jh030-model-back.png?v=1790915264", "preview": "White fit sample \u2014 front", "color": "White"}, "unisex-jersey-long-sleeve-tee": {"front": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-bella-3501-model-front.png?v=1790915988", "back": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-bella-3501-model-back.png?v=1790915995", "preview": "White fit sample \u2014 front", "color": "White"}, "unisex-comfortwash\u00ae-garment-dyed-long-sleeve-t-shirt": {"garmentBack": {"concrete-grey": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hanes-gdh200-concrete-grey-back-fit.png?v=1790992173", "black": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hanes-gdh200-black-back-fit.png?v=1790992177", "navy": "https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hanes-gdh200-navy-back-fit.png?v=1790992182"}}};
    const sampleFit = sampleFitImages[marker.dataset.copyfastProduct];
    const previewLabel = name => Array.from(document.querySelectorAll('.customily_option label')).find(label => label.textContent.trim() === name);
    if (isHoodie) {
      const modelImages = {"black":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hoodie-model-black.jpg?v=1790922383","navy":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hoodie-model-navy.jpg?v=1790922390","royal":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hoodie-model-royal.jpg?v=1790922398","red":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hoodie-model-red.jpg?v=1790922404","sport-grey":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hoodie-model-sport-grey.jpg?v=1790922412","white":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hoodie-model-white.jpg?v=1790922419","forest-green":"https://cdn.shopify.com/s/files/1/1025/0285/9123/files/copyfast-hoodie-model-forest-green.jpg?v=1790922427"};
      const syncModelThumbnail = () => {
        const color = document.querySelector('input[data-option-name="Color"]:checked')?.value;
        const key = color?.toLowerCase().replaceAll(' ', '-');
        const photos = Array.from(document.querySelectorAll('.customily_gallery_thumbnail:not(.canvas-thumbnail)'));
        for (const [index, photo] of photos.entries()) {
          photo.style.setProperty('display', index === 0 ? 'block' : 'none', 'important');
          photo.setAttribute('tabindex', index === 0 ? '0' : '-1');
          if (index !== 0) continue;
          const image = photo.querySelector('img');
          const url = modelImages[key];
          if (image && url && image.src !== url) {
            image.removeAttribute('srcset');
            image.src = url;
            image.alt = color;
          }
          photo.setAttribute('aria-label', 'Model — front');
        }
      };
      let thumbnailTimer;
      const queueThumbnails = () => {
        clearTimeout(thumbnailTimer);
        thumbnailTimer = setTimeout(syncModelThumbnail, 50);
      };
      new MutationObserver(queueThumbnails).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
      document.addEventListener('change', queueThumbnails);
      syncModelThumbnail();
    }
    const syncLiveModelGallery = () => {
      if (isHoodie) return;
      const modelChoice = previewLabel(sampleFit?.preview || 'Model — front');
      if (!modelChoice && !sampleFit?.garmentBack) return;
      const color = document.querySelector('input[data-option-name="Color"]:checked')?.value;
      const key = color?.toLowerCase().replaceAll(' ', '-');
      const fit = isClassic ? classicFitImages[key] : sampleFit;
      const garmentBack = sampleFit?.garmentBack?.[key];
      const photos = Array.from(document.querySelectorAll('.customily_gallery_thumbnail:not(.canvas-thumbnail)'));
      const canvas = document.querySelector('.customily_gallery_thumbnail.canvas-thumbnail');
      if ((isClassic || sampleFit) && canvas) {
        canvas.dataset.copyfastViewLabel = 'Studio';
        canvas.setAttribute('aria-label', 'Studio — edit your design');
      }
      for (const [index, photo] of photos.entries()) {
        const visible = index === 0 || (!garmentBack && (isClassic || sampleFit) && index === 1);
        photo.style.setProperty('display', visible ? 'block' : 'none', 'important');
        photo.setAttribute('tabindex', visible ? '0' : '-1');
        if (!visible) continue;
        const front = !garmentBack && index === 0;
        const label = garmentBack ? 'Back — garment' : front ? (sampleFit ? `${sampleFit.color} model — front` : 'Model — front') : (sampleFit ? `${sampleFit.color} back — fit` : 'Back — fit');
        photo.dataset.copyfastPreviewTarget = front ? (sampleFit?.preview || 'Model — front') : 'back-fit';
        photo.setAttribute('aria-label', label);
        photo.dataset.copyfastViewLabel = label;
        const image = photo.querySelector('img');
        const url = garmentBack || (fit && (front ? fit.front : fit.back));
        if (image && url && image.src !== url) {
          image.removeAttribute('srcset');
          image.src = url;
          image.alt = `${sampleFit?.color || color} — ${front ? 'front model view' : 'back fit reference'}`;
        }
      }
      const reference = document.querySelector('.copyfast-fit-reference');
      const selectedPreview = Array.from(document.querySelectorAll('.customily_option label')).find(label => document.getElementById(label.htmlFor)?.checked && ['Default', 'Studio', sampleFit?.preview || 'Model — front'].includes(label.textContent.trim()))?.textContent.trim();
      const selectedTarget = reference && !reference.hidden ? 'back-fit' : selectedPreview === (sampleFit?.preview || 'Model — front') ? selectedPreview : 'studio';
      for (const thumb of [...photos, canvas].filter(Boolean)) {
        const selected = thumb === canvas ? selectedTarget === 'studio' : thumb.dataset.copyfastPreviewTarget === selectedTarget;
        thumb.classList.toggle('active', selected);
        thumb.setAttribute('aria-selected', String(selected));
      }
      const back = garmentBack || fit?.back;
      if (back && reference && !reference.hidden) {
        const image = reference.querySelector('img');
        if (image.src !== back) image.src = back;
        image.alt = `${sampleFit?.color || color} back fit reference`;
      }
    };
    let liveModelGalleryTimer;
    const queueLiveModelGallery = () => {
      clearTimeout(liveModelGalleryTimer);
      liveModelGalleryTimer = setTimeout(syncLiveModelGallery, 50);
    };
    new MutationObserver(queueLiveModelGallery).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
    document.addEventListener('change', queueLiveModelGallery);
    syncLiveModelGallery();
    const selectPhoto = event => {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      const thumbnail = event.target.closest('.customily_gallery_thumbnail');
      if (!thumbnail) return;
      const gallery = thumbnail.closest('.customily_gallery');
      if (!gallery) return;
      const reference = gallery.querySelector('.copyfast-fit-reference');
      if (thumbnail.classList.contains('canvas-thumbnail')) {
        if (reference) reference.hidden = true;
        gallery.classList.remove('copyfast-show-fit');
        if (event.isTrusted) {
          (previewLabel('Studio') || previewLabel('Default'))?.click();
        }
        queueLiveModelGallery();
        return;
      }
      const photo = thumbnail.querySelector('img');
      const preview = gallery.querySelector('.canvas-thumbnail');
      if (!photo || !preview) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      preview.click();
      const target = thumbnail.dataset.copyfastPreviewTarget;
      const modelName = target && target !== 'back-fit' ? target : isHoodie ? 'Model — front' : photo.src.includes('66d81b70295ea4f038065152') ? 'White sample — front' :
        photo.src.includes('copyfast-bella-3001-model-back') ? 'White sample — back' : null;
      const modelChoice = modelName && Array.from(document.querySelectorAll('.customily_option label')).find(label => label.textContent.trim() === modelName);
      if (modelChoice) {
        if (reference) reference.hidden = true;
        gallery.classList.remove('copyfast-show-fit');
        modelChoice.click();
        queueLiveModelGallery();
        return;
      }
      let panel = reference;
      if (!panel) {
        panel = document.createElement('figure');
        panel.className = 'copyfast-fit-reference';
        const caption = document.createElement('figcaption');
        caption.textContent = isClassic || sampleFit ? `${sampleFit?.color ? sampleFit.color + ' sample. ' : ''}Back fit reference. This product includes front printing only.` : marker.dataset.copyfastGalleryLabel;
        panel.append(caption, document.createElement('img'));
        gallery.querySelector('.customily_gallery_media').after(panel);
      }
      const image = panel.querySelector('img');
      const source = new URL(photo.src);
      source.searchParams.set('width', '720');
      image.src = source.href;
      image.alt = photo.alt || marker.dataset.copyfastGalleryLabel;
      panel.hidden = false;
      if (isClassic || sampleFit) gallery.classList.add('copyfast-show-fit');
      queueLiveModelGallery();
    };
    document.addEventListener('click', selectPhoto, true);
    document.addEventListener('keydown', selectPhoto, true);
  })();
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
    const notice = document.querySelector('[data-print-unavailable]');
    if (notice) notice.hidden = true;
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-print-target]');
    if (!link) return;
    const container = link.closest('.copyfast-print-areas');
    const configurations = JSON.parse(container.querySelector('[data-print-configurations]').textContent);
    const current = Object.values(configurations).find(config => String(config.id) === container.dataset.currentProduct);
    const selectedId = new URL(location.href).searchParams.get('variant') || container.dataset.selectedVariant;
    const selected = current.variants.find(variant => String(variant.id) === selectedId);
    if (!selected) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const destination = configurations[link.dataset.printTarget].variants.find(variant => variant.title === selected.title);
    const notice = container.querySelector('[data-print-unavailable]');
    if (!destination) {
      event.preventDefault();
      event.stopImmediatePropagation();
      notice.hidden = false;
      return;
    }
    notice.hidden = true;
    if (destination) {
      const url = new URL(link.href);
      url.searchParams.set('variant', destination.id);
      link.href = url.toString();
    }
    if (event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(link.href);
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
